import { useAuth } from '@/hooks/useAuth';
import { NavbarDesktop } from './NavbarDesktop';
import { NavbarMobile } from './NavbarMobile';

export const Navbar = () => {
  const { isAuthenticated } = useAuth();

  return (
    <>
      <NavbarDesktop isAuthenticated={isAuthenticated} />
      <NavbarMobile isAuthenticated={isAuthenticated} />
    </>
  );
};
